import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/partner/employees?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`/partner/employees/${id}`, { params });
}

export async function create(body) {
  return request(`/partner/employees`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/partner/employees/${id}`, {
    method: 'POST',
    body,
  });
}